namespace('compass.group');
compass.require('compass.hotel.CancelRoomWidget');
compass.require('compass.group.RoomManageWidget');


compass.group.BlockManageWidget = compass.defineWidget(function BlockManageWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;

	var _settings = options;
	var _blockData = _settings.blockData;
	var _blockEditable = _settings.hotelData.editable && _blockData.editable;

	var _widgetElem;
	var expanded;
	var unassignedRoomManageWidget;

	me.rooms = [];
	var _batchModifyRoomsDialog;
	var _batchModifyRoomsDialogId = compass.generateId();

	me.update = function(updateData) {
		var ajaxSuccess = updateData.data.success;

		var removeRoom = function(room) {
			room.widget.remove();
			me.rooms = _.reject(me.rooms, function(room) {
				return updateData.housing_id === room.housing_id;
			});
			_blockData.numAssignedRooms--;
			_blockData.numTotalRooms--;

			// This doesn't use _blockData.numTotalRooms because that number can potentially higher more than the number
			//  of room widgets actually showing during a search, causing the block to never get removed in the search pane
			if(me.rooms.length + _blockData.numUnassignedRooms > 0) {
				me.find('.numAssignedRooms').empty().append(_blockData.numAssignedRooms);
				me.find('.numTotalRooms').empty().append(_blockData.numTotalRooms);
				if (_blockData.numAssignedRooms === 0) {
					me.find('.assignedRoomsHeader').hide();
				}
			} else {
				me.trigger('BlockManageWidget.removeBlock', {
					hotel_id: _settings.hotelData.hotel_id,
					block_id: _settings.blockData.blockBase.block_id
				});
			}
		};

		var _filterRooms = function(room, arrayOfPeople){
			/* when we are on the main page, updateData.searchText will be empty*/
			if(updateData.filter && !updateData.filter.filterMethod(updateData.filter.searchText, arrayOfPeople)){
				removeRoom(room);
			}
		};

		var updateMethods = {
			cancel: function(room) {
				if (ajaxSuccess) {
					removeRoom(room);
				} else {
					compass.loading.stop();
					var button = $('.CancelRoomWidget').find('.cancelButton.button');
					button.removeClass('disabled');
					button.append("Cancel reservation");
				}
			},
			room: _filterRooms,
			roommates: _filterRooms,
			assignedRooms: function(room, data) {
				unassignedRoomManageWidget.updateUnassignedRooms(_settings.blockData.unassignedRoomsInfo);
			}
		};
		// take updateData and update whatever needs to be done in this widget then pass it on to the roomManageWidget
		_.each(me.rooms, function(room) {
			if(updateData.housing_id === room.housing_id) {
				_.each(updateData.data, function(data, key) {
					if(updateMethods[key]) {
						data.eventData = updateData.eventData; // attaching frontend state event data
						updateMethods[key](room, data);
					}
				});
				room.widget.update(updateData);
			}
		});
	};

	/*udpates blockData information that reflects the fact that a room was assigned, namely, it removes the original room from unassignedRoomsInfo*/
	var _recalculateUnassignedRoomsData = function(originalBlocked_room_id, originalArrive, originalDepart){

		var findUnassignedRooms = function(unassignedRooms) {
			var sameBlockRoom = unassignedRooms.blocked_room_id === originalBlocked_room_id;
			var sameArrive = unassignedRooms.arrive === originalArrive;
			var sameDepart = unassignedRooms.depart === originalDepart;
			return sameBlockRoom && sameArrive && sameDepart;
		};

		var unassignedRooms = _.find(_settings.blockData.unassignedRoomsInfo, findUnassignedRooms);
		unassignedRooms.count--;
		
		if(unassignedRooms.count <= 0) {
			// remove from _settings.blockData.unassignedRoomsInfo
			_settings.blockData.unassignedRoomsInfo = _.filter(_settings.blockData.unassignedRoomsInfo, function(rooms) {
				return !findUnassignedRooms(rooms);
			});
		}
	};

	me.updateAndProcessAssignedRooms = function(assignRoomData) {
		_disableUnassignedRoomFormInputs();
		_fadeOutRoomForm();
		_blockData.assignedRooms.push(assignRoomData.assignedRoomBase);
		_prependAssignedRoom(assignRoomData.assignedRoomBase);
		_recalculateUnassignedRoomsData(assignRoomData.originalBlocked_room_id, assignRoomData.originalArrive, assignRoomData.originalDepart);
		_reassignRoomTotals();
		_redrawRoomManageWidget();
	};

	me.processUnassignedRoomError = function() {
		_redrawRoomManageWidget();
		me.find('.unassignedRoomForm').toggleClass('hasError red_border', true);
	};

	me.render = function(widgetElem) {
		_widgetElem = widgetElem;
		widgetElem.addClass('block_' + _blockData.blockBase.block_id);
		widgetElem.attr('id', _blockData.blockBase.block_id);
		var mainContent;

		if(_blockData.assignedRooms){
			expanded = true;
			mainContent	= _drawMainContent();
		} else {
			expanded = false;
		}

		var mainBlock = d.div({ className: 'blockContainer'},
			_drawMainHeader(_settings.searchMode),
			mainContent
		 );
		widgetElem.append(mainBlock);

		me.remove = function() {
			widgetElem.remove();
		};
	};

	var _toggleRoomSection = function(){
		if(_settings.searchMode) { return; }
		
		$(_widgetElem).find('.blockContainer').find('.roomsSection').slideToggle('slow');
		$(_widgetElem).find('.hotelBlockHeader .blockExpandButton').toggleClass('expanded');
		expanded = !expanded;

		if(expanded) {
			compass.GA.trackEvent('Block Manage', 'View', 'Expand');
		} else {
			compass.GA.trackEvent('Block Manage', 'View', 'Collapse');
		}

		me.find('.assignedAndUnassignedRooms').replaceWith(_getRoomCounts);
	};

	var insertMainContent = function(){
		var roomsContentExists = me.find('.roomsSection').length;
		if(!roomsContentExists){
			var roomsContent = _drawMainContent();
			roomsContent.hide();
			me.find('.hotelBlockHeader').after(roomsContent);
		}
	};

	var _processGetBlockData = function(blockData){
		/* update values in settings so that we can call the proper drawing functions with newest data */
		_blockData.assignedRooms = blockData.names;
		insertMainContent();
		_toggleRoomSection();

	};

	var _getRoomCounts = function() {
		var roomCounts = d.div();
		if(!_settings.searchMode) {
			if (expanded) {
				// 14 rooms
				roomCounts = d.div({ className: 'assignedAndUnassignedRooms'}, d.span({ className: 'numTotalRooms'}, _blockData.numTotalRooms), ' rooms');
			} else {
				// 14 rooms (8 unassigned |  6 assigned)
				roomCounts = d.div({ className: 'assignedAndUnassignedRooms'},
							d.span({ className: 'numTotalRooms'}, _blockData.numTotalRooms), ' rooms (',
							d.span({ className: 'numUnassignedRooms'}, _blockData.numUnassignedRooms), ' unassigned | ',
							d.span({ className: 'numAssignedRooms'}, _blockData.numAssignedRooms), ' assigned)'
				);
			}
		}
		return roomCounts;
	};

	var _drawBlockNotEditableMessage = function() {
		if(_settings.hotelData.editable && !_blockData.editable) {
			return d.div({className: 'blockNotEditableMessage'}, _settings.labels.blockNotEditableMessage);
		}
	};

	var _drawMainHeader = function(){
		var expandButton = d.div();
		if(!_settings.searchMode){
			buttonClassName = expanded ? 'blockExpandButton floatRight expanded' : 'blockExpandButton floatRight';
			expandButton = d.div({ className: buttonClassName}, '');
		}
		
		var hotelBlockClass = 'hotelBlockHeader';
		hotelBlockClass = _settings.searchMode ? hotelBlockClass + ' searchMode' : hotelBlockClass;
		_blockData.blockName = _blockData.blockBase.name ? _blockData.blockBase.name : "Hotel Block Name";

		return [
			d.div({className:hotelBlockClass}, d.div({className:'hotelBlockName'}, _blockData.blockName), expandButton, _getRoomCounts).activate(function() {
				/* if roomtypes data exists, that means we don't need to fire off the event to get the data */
				if(!_blockData.assignedRooms){
					me.trigger('_expandBlock',
						data = {
							onSuccess: _processGetBlockData,
							onFailure: failure,
							data: { block_id : _blockData.blockBase.block_id }
						});
				}
				else{
					insertMainContent();
					_toggleRoomSection();
				}
			})
		];
	};

	var failure = function() {
	};

	var _drawMainContent = function(){
		if (_blockData.numUnassignedRooms <= 0) {
			return d.div({ className: 'roomsSection'},
				_drawBlockNotEditableMessage(),
				_drawAssignedRoomsSection()
			);
		} else {
			return d.div({ className: 'roomsSection'},
				_drawBlockNotEditableMessage(),
				_drawUnassignedRoomsSection(_settings.searchMode),
				_drawAssignedRoomsSection()
			);
		}
	};

	var _reassignRoomTotals = function() {
		if (_blockData.numUnassignedRooms > 1) {
			_blockData.numUnassignedRooms -= 1;
			me.find('.numUnassignedRooms').html(_blockData.numUnassignedRooms);
		} else if (_blockData.numUnassignedRooms == 1) {
			_blockData.numUnassignedRooms -= 1;
			me.find('.numUnassignedRooms').html(_blockData.numUnassignedRooms);
			me.find('.unassignedContainer').slideUp(function() {
				$(this).remove();
			});
		}

		if (_blockData.numAssignedRooms < _blockData.numTotalRooms) {
			_blockData.numAssignedRooms += 1;
			me.find('.numTotalRooms').html(_blockData.numTotalRooms);
			me.find('.numAssignedRooms').html(_blockData.numAssignedRooms);
			me.find('.assignedRoomsHeader').show();
		}
	};

	var _checkUnassignedRoomCancelPermissions = function() {
		var canCancelAnyUnassignedRooms = _.some(_blockData.unassignedRoomsInfo, function(room) {
			return room.canCancel === true;
		});
		return canCancelAnyUnassignedRooms;
	};

	// Removes a member from the loaded Group Member Names list so any newly generated RoomManage widgets exclude this member
	me.bind('RoomManageWidget.removeGroupMemberFromList', function(event, attendance_id) {
		var newGroupMemberList = [];
		var oldGroupMemberList = _settings.groupInfo.groupBase.groupMembers.GROUPMEMBERS;
		for(var memberIndex=0; memberIndex < oldGroupMemberList.length; memberIndex++){
			var memberAttendanceId = oldGroupMemberList[ memberIndex ].ATTENDANCE_ID;
			if (memberAttendanceId !== attendance_id) {
				newGroupMemberList.push( oldGroupMemberList[ memberIndex ] );
			}
		}
		_settings.groupInfo.groupBase.groupMembers.GROUPMEMBERS = newGroupMemberList;
		
		// Replace the list being used by all of the active Name Dropdowns in the groupManage view.
		// Should only run if the widget exists. Typically this widget doesn't exist if the block element has not yet been expanded.
		if (unassignedRoomManageWidget) {
			unassignedRoomManageWidget.trigger('BlockManageWidget.replaceGroupMemberList', [newGroupMemberList] );
		}
	});

	var _drawUnassignedRoomsSection = function(searchMode) {
		if(!searchMode){
			if(!_settings.hotelData.editable || !_blockData.editable) {
				return d.div({className:'unassignedContainer'});
			}

			var unassignedContainer = '';
			/*if the user just assigned the last room, no need to redraw the room widget*/
			if(_blockData.unassignedRoomsInfo.length){
				var manageRoomsLink = d.a({className:'manageRoomsLink', href:'#'}, 'Manage Rooms').activate(function (event) {
					event.preventDefault();
					compass.GA.trackEvent('Modify Unassigned', 'View', 'View Modal');
					_popupBatchModifyModal();
					return false;
				});
				
				unassignedContainer = d.div({className:'unassignedContainer'},
					d.div(
						d.span({ className: 'unassignedRooms'}, d.span({ className: 'numUnassignedRooms'}, _blockData.numUnassignedRooms), ' Unassigned '),
						_blockEditable && _blockData.canCancel && _checkUnassignedRoomCancelPermissions() ? manageRoomsLink : ''
					)
				);

				unassignedRoomManageWidget = new compass.group.RoomManageWidget(unassignedContainer, {
					roomTypes: _blockData.assignableRoomTypes,
					payMethods: _blockData.payMethods,
					hotelData: _settings.hotelData,
					blockData : _settings.blockData,
					nights: _blockData.nights,
					unassignedRoomsInfo: _blockData.unassignedRoomsInfo,
					block_id: _blockData.blockBase.block_id,
					defaultBlocked_room_id : _blockData.mostCommonBlocked_room_id,
					meetingInfo: options.meetingInfo,
					requestsInfo: options.requestsInfo,
					cancelInfo: options.cancelInfo,
					groupInfo: options.groupInfo,
					countriesAndStates: options.countriesAndStates,
					blockEditable: _blockEditable,
					onlyStayRanges: _blockData.onlyStayRanges,
					canCancel: _blockData.canCancel,
					canSendConfo: _settings.canSendConfo,
					memberList: _settings.groupInfo.groupBase.groupMembers.GROUPMEMBERS
				});
			}
			return unassignedContainer;
		}
	};

	var _drawAssignedRoomsSection = function(){
		var roomManageWidgetContainer = d.div({ className: 'roomManageWidgetContainer'});

		var assignedContainer = d.div({ className: 'assignedContainer'},
			_drawAssignedRoomsHeader(),
			roomManageWidgetContainer
		);

		_.each(_blockData.assignedRooms, function(room) {
			var roomManageWidget = new compass.group.RoomManageWidget(roomManageWidgetContainer, {
				roomTypes: _blockData.allRoomTypes,
				payMethods: _blockData.payMethods,
				nights: _blockData.nights,
				assignedRoom: room,
				modifyRoomData: options.modifyRoomData,
				hotelData: _settings.hotelData,
				blockData : _settings.blockData,
				block_id: _blockData.blockBase.block_id,
				meetingInfo: options.meetingInfo,
				requestsInfo: options.requestsInfo,
				cancelInfo: options.cancelInfo,
				groupInfo: options.groupInfo,
				countriesAndStates: options.countriesAndStates,
				blockEditable: _blockEditable,
				onlyStayRanges: _blockData.onlyStayRanges,
				canCancel: _blockData.canCancel,
				canSendConfo: _settings.canSendConfo
			});
			me.rooms.push({housing_id: room.reservationBase.housing_id, widget: roomManageWidget});
		});
		return assignedContainer;
	};

	var _prependAssignedRoom = function(room) {
		if (_blockData.numUnassignedRooms > 0) {
			var container = me.find('.roomManageWidgetContainer');

			var roomManageWidget = new compass.group.RoomManageWidget(undefined, {
				roomTypes: _blockData.allRoomTypes,
				assignedRoom: room,
				modifyRoomData: options.modifyRoomData,
				hotelData: _settings.hotelData,
				blockData : _settings.blockData,
				block_id: _blockData.blockBase.block_id,
				nights: _blockData.nights,
				meetingInfo: options.meetingInfo,
				requestsInfo: options.requestsInfo,
				cancelInfo: options.cancelInfo,
				groupInfo: options.groupInfo,
				countriesAndStates: options.countriesAndStates,
				blockEditable: _blockEditable,
				onlyStayRanges: _blockData.onlyStayRanges,
				canCancel: _blockData.canCancel,
				canSendConfo: _settings.canSendConfo
			});

			/*getWidgetElem is required because widget.find is actually a wrapper for jquery.find method
			that accesses the original container (compass.js:widgetBase:_widgetElem) created in compass.js:componentBuilder. 
			(the original container was created above by calling the 'new RoomManageWidget') */
			/*without doing it this way; bind, unbind, trigger, find methods defined in widgetBase don't reference the correct container*/
			$j(roomManageWidget.getWidgetElem()).hide().prependTo(container).slideDown();
			me.rooms.push({housing_id: room.reservationBase.housing_id, widget: roomManageWidget});
		}
	};

	var _drawAssignedRoomsHeader = function() {
		var assignedRoomHeader = d.div({ className: 'assignedRoomsHeader'}, d.span({ className: 'numAssignedRooms'}, _blockData.numAssignedRooms), ' Assigned');
		if (_blockData.numAssignedRooms === 0 || _settings.searchMode) {
			assignedRoomHeader.hide();
		}
		return assignedRoomHeader;
	};

	var _popupBatchModifyModal = function(){
		var batchManagePopupDiv = d.div();
		var batchModifyRoomsWidget = new compass.group.BatchModifyRoomsWidget(batchManagePopupDiv, {
			WUID: 'groupManage_batchModifyRoomsWidget',
			blockData: _blockData,
			hotelData: _settings.hotelData,
			currencyFormatter: _settings.meetingInfo.defaultCurrencyFormatter,
			cancelReasons : _settings.cancelReasons,
			cancelFee: _settings.cancelInfo.cancelFee
		});

		_batchModifyRoomsDialog = d.dialog({
			id : _batchModifyRoomsDialogId,
			centerOnView : true,
			classes : 'batchModifyRoomsDialog',
			modal : true,
			contents : batchManagePopupDiv,
			showParent : true,
			disableClicksOutsideModal : true
		});

		_batchModifyRoomsDialog.bind(_batchModifyRoomsDialog.EVENTS.CLOSE, function () {
			compass.GA.trackEvent('Modify Unassigned', 'Close', 'Close Modal');
		});
	};

	var _disableUnassignedRoomFormInputs = function() {
		me.find('.unassignedFirstName, .unassignedLastName, .unassignedEmail').attr('disabled', 'true');
		me.find("[name='unassignedRoomTypes']").attr('disabled', 'true');
		me.find(".saveButton").addClass("disabled");
	};

	var _fadeOutRoomForm = function() {
		me.find('.unassignedRoomForm').fadeOut("slow");
	};

	var _redrawRoomManageWidget = function() {
		var unassignedContainer = me.find('.unassignedContainer');

		
		var content = _drawUnassignedRoomsSection(_settings.searchMode);
		unassignedContainer.replaceWith(content);

		me.find('.unassignedFirstName').focus();
		me.find('.saveButton').removeClass('disabled');
	};

}, {
	WUID: 'DEFAULT',
	widgetName: 'BlockManageWidget',
	hotelData: {},
	blockData: {},
	meetingInfo: {},
	requestsInfo: {},
	cancelInfo: {},
	groupInfo: {},
	countriesAndStates: {},
	searchMode: false,
	labels: {
		blockNotEditableMessage: 'This block is closed and reservations can no longer be edited.'
	}
});
